// 追従バナー
document.addEventListener('DOMContentLoaded', () => {
  const banner = document.getElementById('banner');
  if (!banner) return;

  const close = banner.querySelector('.close');
  if (close) {
    close.addEventListener('click', () => {
      banner.classList.add('closed');
      // 1日有効の Cookie を設定
      const expires = new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = `bannerVisibility=false; expires=${expires}; path=/`;
    });
  }

  const toggleBanner = () => {
    let min = 0;
    if (document.body.classList.contains('top')) {
      const service = document.getElementById('service');
      if (service) min = service.getBoundingClientRect().top + window.pageYOffset;
    }
    const footer = document.querySelector('#contents>footer');
    const max = footer ? footer.getBoundingClientRect().top + window.pageYOffset : Infinity;
    const windowBottom = window.pageYOffset + window.innerHeight;
    banner.classList.toggle('hidden', windowBottom < min || max < windowBottom);
  };

  toggleBanner();
  window.addEventListener('scroll', toggleBanner, { passive: true });
  window.addEventListener('resize', toggleBanner);
});
